import React from 'react';
import { Link } from 'react-router-dom';

const HeaderTopbar = () => {
    return (
        <div className="topbar">
            <div className="container-fluid">
                <div className="row">
                    <div className="col col-md-7 col-sm-12 col-12">
                        <div className="contact-intro">
                            <ul>
                                <li>
                                    <i className="fi ti-location-pin"></i>CR 12 24 45 Cajica Cundinamarca
                                </li>
                                <li>
                                    <i className="fi flaticon-email"></i>contacto@jansconsulting.com.co
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col col-md-5 col-sm-12 col-12">
                        <div className="contact-info">
                            <ul>
                                <li>Visita Nuestras Redes Sociales</li>
                                <li>
                                    <a
                                        href="https://www.youtube.com/@JANSCONSULTING"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <i className="ti-youtube"></i>
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href="https://web.facebook.com/JANS.Consulting"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <i className="ti-facebook"></i>
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href="https://www.instagram.com/jansconsulting/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <i className="ti-instagram"></i>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HeaderTopbar;